import { initState as initDimensionState } from "@reducers/selectors/dimension";
import { APP_TYPES } from "@config";

export default {
  headSize: 5,
  radius: 10,
  maxLength: {
    active: false,
    value: 0
  },
  count: {
    n: 2,
    m: 4
  },
  padding: {
    s: initDimensionState[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.s,
    d: initDimensionState[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.d
  },
  shift: {
    c: initDimensionState[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.c,
    c1: initDimensionState[APP_TYPES.REBAR_REINFORCEMENT].reinforcementParameters.c1
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/screw/defaults/rebarReinforcement.js